/*=========================================================================================
  File Name: moduleBackend.js
  Description: Backend Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Backendor: Pixinvent
  Backendor URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleBackendState.js'
import mutations from './moduleBackendMutations.js'
import actions from './moduleBackendActions.js'
import getters from './moduleBackendGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
